import { postAssetUpload } from '../../../apis/article.api';
import axios from 'axios';
import { getContentType } from '../../../constants/image.constant';
import { useCallback } from 'react';

export default () => {
  const getContentKeyFromBlobOrBase64 = async (src: string, fileName: string) => {
    try {
      if (src.startsWith('data:') || src.startsWith('blob:http')) {
        let file: any;
        const contentKeys = await postAssetUpload({
          fileName: [fileName]
        });
        const url = contentKeys[0].url;

        if (src.startsWith('data:')) {
          // Handle base64
          const [header, base64Data] = src.split(',');
          const contentType = header.match(/:(.*?);/)?.[1] || 'image/png';
          const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0));
          file = new File([binaryData], fileName, { type: contentType });
        } else {
          // Handle blob
          const response = await fetch(src);
          const blob = await response.blob();
          file = new File([blob], fileName, { type: blob.type });
        }

        await axios.put(url, file, {
          headers: {
            'content-disposition': 'inline',
            'Content-Type': getContentType(file?.name.toLowerCase()),
            'x-amz-acl': 'public-read'
          }
        });

        return contentKeys[0].key;
      } else if (src.startsWith('http')) {
        return src.split('/').slice(3).join('/').split('?')[0];
      } else {
        throw new Error('Unsupported source format.');
      }
    } catch (error) {
      console.error('Error processing asset:', error);
      throw error;
    }
  };

  const convertHttpUrl = (url: string) => {
    if (url && url.startsWith('http')) {
      return url.split('/').slice(3).join('/').split('?')[0];
    }
    return url;
  };

  async function updateSrcNode(node: any) {
    if (!node) return;

    // Handle src property
    if (node.hasOwnProperty('src') && !(node.imageType && node.imageType === 'gif')) {
      const fileName = `file_${Date.now()}`;
      let contentKey: any;

      if (
        node.src.startsWith('blob:http') ||
        node.src.startsWith('data:') ||
        node.src.startsWith('http')
      ) {
        const isVideo = node.type === 'video';
        const isAudio = node.type === 'audio';
        let fileExtension = 'png';

        if (isAudio) {
          fileExtension = 'mp3';
        } else if (!isVideo) {
          const urlExtension = node.src.split('.').pop()?.split(/[#?]/)[0]?.toLowerCase();
          // Convert all non-GIF images to WebP
          if (urlExtension !== 'gif') {
            fileExtension = 'webp';
          } else {
            fileExtension = 'gif';
          }
        } else {
          fileExtension = 'mp4';
        }

        contentKey = await getContentKeyFromBlobOrBase64(node.src, `${fileName}.${fileExtension}`);
      } else {
        contentKey = node.src;
      }

      node.src = contentKey;
    }

    // Handle imgUrl in mention data
    if (node.type === 'custom-beautifulMention' && node.data?.imgUrl) {
      node.data.imgUrl = convertHttpUrl(node.data.imgUrl);
    }

    // if (node.contributors?.imgUrl) {
    //   node.contributors.imgUrl = convertHttpUrl(node.contributors.imgUrl);
    // }

    if (node.children && node.children.length) {
      for (let child of node.children) {
        await updateSrcNode(child);
      }
    }
  }

  return useCallback(async (data) => {
    await updateSrcNode(data.editorState.root);
    return data;
  }, []);
};
